<template lang="pug">
#app
	mqtt-manager(:reconnect="true")
	session-manager(:IsUserIdle="IsUserIdle" @ResetTimer="setIsUserIdle(true)")
	site-header
	#view
		slot(name="breadcrumbs"): breadcrumbs
		slot: router-view
		toasts(:toasts="$store.getters.mostRecentToasts")
</template>

<script>
import API from "@/api/index";
import ActionTypes from "@/store/action-types";
import SiteHeader from "@/components/SiteHeader";
import Breadcrumbs from "@/components/Breadcrumbs";
import SessionManager from "@/components/SessionManager";
import MqttManager from "@/components/mqtt-manager";
import MqttClient from "@/components/mqtt-client";
import Toasts from "@/components/Toasts";
import _ from "lodash";

export default {
	components: {
		Toasts,
		SessionManager,
		MqttManager,
		MqttClient,
		Breadcrumbs,
		SiteHeader
	},
	data: () => ({
		IsUserIdle: false
	}),
	computed: {
		userIsLoggedIn() {
			return this.$store.getters.isLoggedIn;
		}
	},
	watch: {
		userIsLoggedIn(val) {
			if (val === true) {
				this.$store.dispatch(ActionTypes.FETCH_MQTT_CREDENTIALS);
			}
		}
	},
	beforeMount() {
		API.setBaseUrl(this.$store.getters.apiUrl);
		window.__$store = this.$store;
	},
	mounted() {
		document.addEventListener(
			"mousemove",
			_.debounce(() => {
				this.setIsUserIdle(false);
			}, 1000)
		);
		document.addEventListener(
			"keypress",
			_.debounce(() => {
				this.setIsUserIdle(false);
			}, 1000)
		);
	},
	methods: {
		setIsUserIdle(val) {
			this.IsUserIdle = val;
		}
	}
};
</script>

<style lang="stylus"></style>
